// extracted by mini-css-extract-plugin
var _1 = "sAfCU";
var _2 = "PaYLi";
export { _1 as "base", _2 as "tab" }
